import React from 'react'

import clsx from 'clsx'

import { Button, makeStyles } from '@material-ui/core'

import { NextButton } from 'components'
import useSubscribe from 'hooks/useSubscribe'
import styles from './styles'

const useStyles = makeStyles(styles)

const Footer = ({
  prevButtonText = 'Voltar',
  prevButtonProps = {},
  nextButtonText = 'Continuar',
  nextButtonProps = {},
  className,
}) => {
  const classes = useStyles()
  const subscribe = useSubscribe()

  const handleClickBackButton = () => {
    subscribe.backStep()
  }

  return (
    <div className={clsx(classes.buttonGroup, className)}>
      <NextButton
        variant="contained"
        type="submit"
        size="large"
        {...nextButtonProps}
      >
        {nextButtonText}
      </NextButton>

      <Button
        variant="text"
        color="primary"
        size="large"
        className={classes.backButton}
        onClick={handleClickBackButton}
        {...prevButtonProps}
      >
        {prevButtonText}
      </Button>
    </div>
  )
}

export default Footer
